/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Overviewgreetingafternoon2Inputs */

const en_overviewgreetingafternoon2 = /** @type {(inputs: Overviewgreetingafternoon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Good afternoon, ${i?.name}`)
};

const de_overviewgreetingafternoon2 = /** @type {(inputs: Overviewgreetingafternoon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guten Tag, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Good afternoon, {name}" |
*
* @param {Overviewgreetingafternoon2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewgreetingafternoon2 = /** @type {((inputs: Overviewgreetingafternoon2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewgreetingafternoon2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewgreetingafternoon2(inputs)
	return de_overviewgreetingafternoon2(inputs)
});
export { overviewgreetingafternoon2 as "overviewGreetingAfternoon" }